import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import { Column, G2, Pie } from "@ant-design/plots";
import { Divider, Space, Select, Radio, DatePicker, Tabs } from "antd";
import "./style";
import {
  getOrderCountByYear,
  getOrderCountByYearMonth,
  getOrderCountByYearQuarter,
} from "../../services/Stat";
import { getList as getBuyerList } from "../../services/Buyer";
import { getList as getGoodsList } from "../../services/Goods";
const { RangePicker } = DatePicker;
export default React.forwardRef((props, ref) => {
  const G = G2.getEngine("canvas");
  const [data, setData] = useState([]);
  const [group, setGroup] = useState(1);
  const [buyerList, setBuyerList] = useState([]);
  const [selectedBuyerId, setselectedBuyerId] = useState(0);
  const [chartConfig, setChartConfig] = useState({
    height: 300,
    data: data,
    appendPadding: 10,
    angleField: "value",
    colorField: "type",
    radius: 0.75,
    legend: false,
    label: {
      type: "spider",
      labelHeight: 40,
      formatter: (data, mappingData) => {
        const group = new G.Group({});
        group.addShape({
          type: "circle",
          attrs: {
            x: 0,
            y: 0,
            width: 40,
            height: 50,
            r: 5,
            fill: mappingData.color,
          },
        });
        group.addShape({
          type: "text",
          attrs: {
            x: 10,
            y: 8,
            text: `${data.type}`,
            fill: mappingData.color,
          },
        });
        group.addShape({
          type: "text",
          attrs: {
            x: 0,
            y: 25,
            text: `${data.value}个 ${data.percent * 100}%`,
            fill: "rgba(0, 0, 0, 0.65)",
            fontWeight: 700,
          },
        });
        return group;
      },
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
  });
  const [chartType, setChartType] = useState(0);
  const [orderType, setOrderType] = useState("buyer");

  useEffect(() => {
    if (orderType === "buyer")
      getBuyerList().then((data) => {
        setBuyerList(data);
        setData(data.map(x=>({type: x.name_en, value: 50})))
      });
    else
      getGoodsList().then((data) => {
        setBuyerList(data);
      });
    setselectedBuyerId(0);
  }, [orderType]);

  useEffect(() => {
    if (group === 0) {
    } else if (group === 1) {
    } else if (group === 2) {
    }
  }, [orderType, group, selectedBuyerId]);

  useEffect(() => {
    setChartConfig({
      height: 300,
      data: data,
      appendPadding: 10,
      angleField: "value",
      colorField: "type",
      radius: 0.75,
      legend: false,
      label: {
        type: "spider",
        labelHeight: 40,
        formatter: (data, mappingData) => {
          const group = new G.Group({});
          group.addShape({
            type: "circle",
            attrs: {
              x: 0,
              y: 0,
              width: 40,
              height: 50,
              r: 5,
              fill: mappingData.color,
            },
          });
          group.addShape({
            type: "text",
            attrs: {
              x: 10,
              y: 8,
              text: `${data.type}`,
              fill: mappingData.color,
            },
          });
          group.addShape({
            type: "text",
            attrs: {
              x: 0,
              y: 25,
              text: `${data.value}个 ${data.percent * 100}%`,
              fill: "rgba(0, 0, 0, 0.65)",
              fontWeight: 700,
            },
          });
          return group;
        },
      },
      interactions: [
        {
          type: "element-selected",
        },
        {
          type: "element-active",
        },
      ],
    });
  }, [data]);

  const onChange = (e) => {
    setselectedBuyerId(e.target.value);
  };

  const onChangeType = (e) => {
    console.log("ordertype:", e.target.value);
    setOrderType(e.target.value);
  };

  let total = 0;
  data.forEach((x) => {
    total += x.count;
  });
  return (
    <div>
      <div className="stat-body-header">
        <strong>请选择分析类型：</strong>
        <Radio.Group value={orderType} onChange={onChangeType}>
          <Radio.Button value="buyer">订单量对比</Radio.Button>
          <Radio.Button value="goods">常用产品对比</Radio.Button>
          <Radio.Button value="overpass">超过常规分析</Radio.Button>
        </Radio.Group>
      </div>
      <div className="stat-body">
        <div className="dashboard-container">
          <div className="dashboard">
            <div className="group">
              <strong>统计周期：</strong>
              <RangePicker />
              &nbsp;&nbsp;
              <Select value={chartType} onChange={(val) => setChartType(val)}>
                <Select.Option value={0}>饼图</Select.Option>
              </Select>
            </div>
            <div className="title">订单数量统计分析(当前共计：{total})</div>
            <div className="sub-title"></div>
            {chartType === 0 && (
              <Pie
                key={"key-" || new Date().getTime()}
                className="chart"
                {...chartConfig}
              />
            )}
          </div>
          <div className="data">
            订单数量统计分析明细
            <table
              style={{
                borderTop: "1px solid #ccc",
                borderRight: "1px solid #ccc",
              }}
              className="table"
            >
              <thead>
                <tr className="tr">
                  <th className="td">#</th>
                  <th className="td">周期</th>
                  <th className="td">数量</th>
                  <th className="td">备注</th>
                </tr>
              </thead>
              <tbody>
                {data.map((x, i) => {
                  return (
                    <tr className="tr">
                      <td className="td">{i + 1}</td>
                      <td className="td">
                        <a>{x.label}</a>
                      </td>
                      <td className="td">{x.count}</td>
                      <td className="td"></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="panel">
          <Radio.Group onChange={onChange} value={selectedBuyerId}>
            <Radio value={0}>
              所有{orderType === "buyer" ? "客户" : "产品"}
            </Radio>
            <Divider />
            <Space direction="vertical">
              {buyerList.map((x) => {
                return <Radio value={x.id}>{x.name_en || x.name}</Radio>;
              })}
            </Space>
          </Radio.Group>
        </div>
      </div>
    </div>
  );
});
